// React
import { useEffect, useState, useRef } from "react";
import clsx from "clsx";

// Interfaces
import { ICollapsiblePanel } from "./interfaces";

// MUI
import { Box, Button, ClickAwayListener, Slide } from "@mui/material";

// Icons
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import HttpsOutlinedIcon from "@mui/icons-material/HttpsOutlined";
import Unlock from "@/assets/icons/layouts/CommissionSideBar/Unlock.svg";

export default function CollapsibleLeftPanel(props: Readonly<ICollapsiblePanel>) {
	const { control, open = false, permanentTrigger = false, disabled = false } = props;
	const [collapsed, setCollapsed] = useState(true);
	const [permanent, setPermanent] = useState(false);
	const containerRef = useRef(null);

	const handleExpandToggle = () => {
		setCollapsed(!collapsed);
	};

	useEffect(() => {
		let currentCollapsed = true;
		if (typeof open !== "undefined") {
			currentCollapsed = !open;
		}
		setCollapsed(currentCollapsed);
	}, [open]);

	useEffect(() => {
		if (permanent || disabled) {
			setCollapsed(true);
		}
	}, [permanent, disabled, permanentTrigger]);

	return (
		<ClickAwayListener
			onClickAway={() => {
				setCollapsed(true);
			}}
		>
			<Box
				className={collapsed ? "collapse-left-box collapse-left-box-collapsed" : "collapse-left-box"}
				ref={containerRef}
				sx={{ overflow: "hidden" }}
			>
				<Button
					className={clsx({
						"collapse-left-panel-btn": true,
						"collapse-left-panel-btn-collapsed": collapsed,
						"!bg-disabled": disabled,
					})}
					disabled={disabled}
					onClick={handleExpandToggle}
				>
					{collapsed ? <ArrowForwardIosRoundedIcon className="text-white" /> : <ArrowBackIosRoundedIcon className="text-white" />}
				</Button>

				<Button
					className={clsx({
						"collapse-left-panel-btn": true,
						"permanent-btn-handler": true,
						"permanent-btn-handler-collapsed": collapsed,
					})}
					disabled={disabled}
					onClick={() => setPermanent(!permanent)}
				>
					{!permanent ? (
						<HttpsOutlinedIcon sx={{ fontSize: "23px" }} />
					) : (
						<img style={{ marginLeft: "5px", marginBottom: "1px" }} width={20} src={Unlock} alt="" />
					)}
				</Button>

				<Slide direction="right" in={!collapsed} container={containerRef.current} timeout={150}>
					<Box className="collapse-left-panel">{control}</Box>
				</Slide>
			</Box>
		</ClickAwayListener>
	);
}
